export default "__VITE_ASSET__353edb7d__"